import { UserLoggedInNavigatorScreenProps } from "@/src/TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { overviewWidgetSizes } from "../../WidgetAdd/utils/widgetSizes/overviewWidgetSizes";

import { useCallback, useState } from "react";
import { WidgetSizeT } from "../../localTypes/WidgetSizeT";
import { withWebModal } from "@/src/TopLevelNavigators/UserLoggedIn/withWebModal";
import { WACalendarOverviewPreview } from "./WACalendarOverviewPreview";
import { graphql, useMutation } from "react-relay";
import { WAWidgetSizeToOverviewSize } from "../../WidgetAdd/utils/WAWidgetSizeToOverviewSize";
import { WidgetCalendarOverviewSettings } from "./WidgetCalendarOverviewSettings";
import { WACalendarOverviewContext } from "./WACalendarOverviewContext";
import { useFocusEffect } from "@react-navigation/native";
import { useWidgetCalendarPreviewOverviewQuery } from "./useWidgetCalendarPreviewOverviewQuery";
import { WASizePreview } from "../../WidgetAdd/WASizePreview/WASizePreview";
import { WidgetScreen } from "../../common/WidgetScreen";

type Props = UserLoggedInNavigatorScreenProps<"WidgetAddCalendarOverview">;

function InnerWACalendarOverview(props: Props) {
  const [calendarIds, setCalendarIds] = useState<string[]>([]);
  const [previewQuery, loadPreviewQuery] =
    useWidgetCalendarPreviewOverviewQuery({
      storecastId: props.route.params.storecastId,
    });

  useFocusEffect(
    useCallback(() => {
      loadPreviewQuery(calendarIds);
    }, [loadPreviewQuery, calendarIds])
  );

  const onSelectCalendarIds = useCallback(
    (calendarIds: string[]) => {
      setCalendarIds(calendarIds);
      loadPreviewQuery(calendarIds);
    },
    [loadPreviewQuery, setCalendarIds]
  );

  const [createWidgetCalendarOverviewMutation,] = useMutation(graphql`
    mutation WACalendarOverviewMutation(
      $storecastId: ID!
      $input: CreateWidgetCalendarOverviewInput!
    ) {
      dashboard(dashboardId: $storecastId) {
        createWidgetCalendarOverview(widget: $input) {
          id
        }
      }
    }
  `);

  const onCreate = useCallback(
    (size: WidgetSizeT) => {
      createWidgetCalendarOverviewMutation({
        variables: {
          storecastId: props.route.params.storecastId,
          input: {
            positionX:
              props.route.params.position.x + props.route.params.position.c * 2,
            positionY: props.route.params.position.y,
            size: WAWidgetSizeToOverviewSize(size),
            calendarIds: calendarIds,
          },
        },
        onCompleted: () => {
          props.navigation.pop(2);
        },
      });
    },
    [
      createWidgetCalendarOverviewMutation,
      props.navigation,
      props.route.params.position.c,
      props.route.params.position.x,
      props.route.params.position.y,
      props.route.params.storecastId,
      calendarIds,
    ]
  );

  return (
    <WidgetScreen
      settings={
        <WACalendarOverviewContext.Provider
          value={{
            calendarIds,
            setCalendarIds: onSelectCalendarIds,
          }}
        >
          <WidgetCalendarOverviewSettings
            onClose={() => props.navigation.goBack()}
          />
        </WACalendarOverviewContext.Provider>
      }
      preview={
        <WASizePreview
          loading={false}
          widgetSizes={overviewWidgetSizes}
          unitSize={props.route.params.unitSize}
          maxSize={props.route.params.maxSize}
          onCreate={onCreate}
        >
          {previewQuery ? (
            <WACalendarOverviewPreview query={previewQuery} />
          ) : null}
        </WASizePreview>
      }
    />
  );
}

export const WACalendarOverview = withWebModal(InnerWACalendarOverview, true);
